<template lang="pug">
    model-form(
        ref="form"
        reset-text="restablecer"
        submit-text="guardar"
        switch-edit
        v-bind="formProps"
        v-model="formData"
        @reset="reset"
        @submit="submit"
    )
        template( slot="footer-actions" slot-scope="{ wait }" )
            v-btn(
                block
                class="ml-3"
                color="success"
                :disabled="wait"
                v-if="formData.can_authorize"
                @click="submitAuthorize"
            ) autorizar
            v-btn(
                block
                class="ml-3"
                color="secondary"
                :disabled="wait"
                v-if="formData.can_confirm"
                @click="submitConfirmPay"
            ) confirmar
            v-btn(
                block
                class="ml-3"
                color="error"
                :disabled="wait"
                v-if="formData.can_reject"
                @click="submitReject"
            ) rechazar
        template( slot="header-actions" slot-scope="{ wait }" )
            v-tooltip( bottom )
                v-btn(
                    color="success"
                    :disabled="wait"
                    :loading="formDownloading"
                    slot="activator"
                    style="margin: -8px 0"
                    v-if="formData.can_txt"
                    @click="submitTxt"
                ) descargar &nbsp;
                    v-icon cloud_download
                span Descargar en archivo
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import ProviderPaymentSheetModel from '@/models/Purchase/PchProviderPaymentSheet'
    import UpdateProviderPaymentSheetFields from '@/views/Purchase/PchProviderPaymentSheet/partials/UpdateProviderPaymentSheetFields'
    //
    export default {
        name: 'provider-payment-sheet',
        components: {
            ModelForm,
        },
        computed: {
            //
            ...mapState('AuthModule', [
                'user',
            ]),

            /**
             * 
             */
            fieldsProps() {
                return {
                    selected_payment_date: this.formData.payment_date,
                    payment_date_trigger: this.refresh,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    editable: this.formData.can_edit,
                    fields: UpdateProviderPaymentSheetFields( this.formData ),
                    noSubmit: ! this.formData.can_update,
                    switchEdit: this.formData.can_edit,
                    title: this.title,
                }
            },

            /**
             *
             */
            title() {
                return 'Nomina de pago #' + this.$route.params.id
            }
        },
        data() {
            return {
                formData: {},
                formDownloading: false,
            }
        },
        methods: {
            //
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            //
            ...mapActions('SnackbarModalModule', [
                'resetSnackbarState',
                'setErrorSnackbar',
                'setWarningSnackbar',
                'setSuccessSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                return this.setErrorSnackbar(
                    TranslatorService(ProviderPaymentSheetModel, error.response.data)
                )
            },

            /**
             *
             */
            fetch() {
                return ProviderPaymentSheetModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'provider-payment-sheet-list' })
            },

            /**
             * 
             */
            refresh() {
                this.reset()
            },

            /**
             *
             */
            reset() {
                this.$refs.form.setWait(true).then(this.fetch).then(this.$refs.form.setWait)
            },

            /**
             *
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             *
             */
            submit() {
                this.$refs.form.setWait(true).then(this.toUpdate).then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitAuthorize() {
                this.$refs.form.setWait(true).then(this.toAuthorize).then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitConfirmPay() {
                this.$refs.form.setWait(true).then(this.toConfirmPay).then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitExcel() {
                this.toggleDownloading().then(this.toExcel).then(this.toggleDownloading)
            },

            /**
             *
             */
            submitReject() {
                this.$refs.form.setWait(true).then(this.toReject).then(this.$refs.form.setWait)
            },

            /**
             *
             */
            submitTxt() {
                this.toggleDownloading().then(this.toTxt).then(this.toggleDownloading)
            },

            /**
             *
             */
            successAuthorize() {
                return this.setSuccessSnackbar('Nómina de pago autorizada exitosamente.')
            },

            /**
             *
             */
            successConfirmPay() {
                return this.setSuccessSnackbar('Nómina de pago confirmada exitosamente.')
            },

            /**
             *
             */
            successReject() {
                return this.setSuccessSnackbar('Nómina de pago rechazada exitosamente.')
            },

            /**
             *
             */
            successUpdate() {
                return this.setSuccessSnackbar('Nómina de pago actualizada exitosamente.')
            },

            /**
             *
             */
            async toggleDownloading() {
                this.formDownloading = ! this.formDownloading
            },

            /**
             *
             */
            toAuthorize(model) {
                return model
                    .authorize()
                    .attach(model.toAuthorize())
                    .then(this.successAuthorize)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             *
             */
            toConfirmPay(model) {
                return model
                    .confirmPay()
                    .attach(model.toConfirm())
                    .then(this.successConfirmPay)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             *
             */
            async toExcel() {
                return await this.formData.toExcel()
            },

            /**
             *
             */
            async toTxt() {
                return await this.formData.toTxt()
            },

            /**
             *
             */
            toReject(model) {
                return model
                    .reject()
                    .attach(model.toReject())
                    .then(this.successReject)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.refresh)
                    .catch(this.error)
            },
        },
        beforeMount() {
            this.setTitleTopBar(this.title)
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('CREATE_PAYMENT_SHEET')) ctx.$router.push('/')
            })
        },
        mounted() {
            this.reset()
        },
    }
</script>
